import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { setError } from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { mapToObjectDDL } from "../../../../common/mapper";
import ReportProspek from "./components/reportProspek";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus } from "../../../../common/Constants";

class DashboardProspekDailyKabengKacab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
      kodeCabang: null,
      search: {
        kodeCabang: null,
      },
      loading: false,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  fetchDataCabang = async () => {
    this.handleTriggerLoading();

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Dashboard CRM Kabeng Kacab - Prospek Daily",
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang)
      );

      if (filteredData.length !== 0) {
        this.setState((prev) => ({
          ...prev,
          cabangOptions: filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          ),
          kodeCabang: mapToObjectDDL(
            filteredData[0].namaDealer,
            filteredData[0].kodeCabang
          ),
          search: {
            kodeCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang
            ),
          },
        }));
      }
    }
  };

  handleSelectCabang = (value) => {
    this.setState((prev) => ({
      ...prev,
      kodeCabang: value,
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  handleSearch = () => {
    this.setState((prev) => ({
      ...prev,
      search: {
        kodeCabang: prev.kodeCabang,
      },
    }));
  };

  render() {
    const { cabangOptions, kodeCabang, search, loading } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView
            style={{ gap: "20px" }}
            className="margin-top-15px"
            vAlignContent="center"
          >
            <label className="margin margin-bottom-15px">Cabang</label>
            <SimpleDDL
              id="select_options_kode_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-350px"
              placeholder="Nama Cabang"
              options={cabangOptions}
              value={kodeCabang}
              onChange={(value) => this.handleSelectCabang(value)}
            />
            <SimpleButton
              id="btn_search"
              text="Cari"
              className="margin margin-bottom-15px"
              onClick={this.handleSearch}
            />
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Statistik Prospek Today</Tab>
              <Tab>Laporan Appointment Follow Up Hari Ini</Tab>
              <Tab>Laporan Appointment Overdue</Tab>
            </TabList>
            <TabPanel key="statistik_prospek_today">
              <ReportProspek
                {...this.props}
                tab="prospek_today"
                kodeCabang={search?.kodeCabang}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel key="appointment_fu_today">
              <ReportProspek
                {...this.props}
                tab="appointment_today"
                kodeCabang={search?.kodeCabang}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel key="statistik_appointment_overdue">
              <ReportProspek
                {...this.props}
                tab="appointment_overdue"
                kodeCabang={search?.kodeCabang}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setError: (payload) => dispatch(setError(payload)),
});

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardProspekDailyKabengKacab);
